<template>

    <!-- Common Banner Area -->
    <ConsultarSaldoBanner />

    <!--Error Areas -->
    <ConsultarSaldoArea />

    <!-- Cta Area -->
    <!-- <Cta /> -->

</template>
<script>
import ConsultarSaldoBanner from '@/components/pages/ConsultarSaldoBanner.vue'
import ConsultarSaldoArea from '@/components/pages/ConsultarSaldoArea.vue'
import Cta from '@/components/home/Cta.vue'

export default {
    name: "ConsultarSaldoView",
    components: {
        ConsultarSaldoBanner, ConsultarSaldoArea, Cta
    }
};
</script>